import React from 'react';

/**
 * Card Component
 * Container component with optional header, footer, and variants
 * Provides consistent spacing and visual separation
 */

export default function Card({
  title,
  subtitle,
  children,
  footer,
  variant = 'default',
  className = ''
}) {
  const variants = {
    default: 'bg-white border border-neutral-200 shadow-md',
    outline: 'bg-white border-2 border-neutral-300',
    ghost: 'bg-transparent border border-transparent'
  };

  return (
    <div className={`rounded-lg ${variants[variant]} ${className}`}>
      {(title || subtitle) && (
        <div className="p-4 border-b border-neutral-200">
          {title && <h3 className="text-lg font-semibold text-neutral-900">{title}</h3>}
          {subtitle && <p className="text-sm text-neutral-600 mt-1">{subtitle}</p>}
        </div>
      )}

      <div className="p-4">{children}</div>

      {footer && (
        <div className="p-3 border-t border-neutral-200 bg-neutral-50 rounded-b-lg">{footer}</div>
      )}
    </div>
  );
}
